<template>
    <Oom
        :config="config"
        :tm_params="tm_params"
        :data="data"
        :id="id"
    />
</template>

<script>
import { Oom } from "@ocs-software/vue-ocs";
export default {
  name: "statsTable",
  props: ["id", "stat", "data", "config"],
  components: {
    Oom
  },
  data() {
    return {
      noData: "noData",
      flag: "flag",
      cell: "cell",
      fields: "fields",
      name: "name",
    };
  },
  filters: {
    lowercase: function(value) {
      if (!value) {
        return "";
      }
      return value.toLowerCase() + ".svg";
    },
  },
};
</script>

<style scoped>
td.cut {
  color: #ffffff;
  text-align: left;
}
tr.cutBK {
    background-color: black;
    color: #ffffff;
}
td.playerNameNon.cell.name {
  font-weight: 400;
}
td.noBold.cell {
  font-weight: 500;
  color: #707070;
}
td.playerName.cell.name > a:hover{
  color:#C8102E!important;
  text-decoration: none;
}
tr:nth-child(even) {
  background-color: #F5F5F5;
}
.noData {
  text-align: center;
  padding-top: 5%;
  padding-bottom: 5%;
  height: 200px;
}
.flag {
  width: 30px;
  box-shadow: 0 0 3px #555;
}

.fields {
  background-color: #C8102E;
  color: white;
  font-weight: 400;
}
::v-deep td {
  text-align: center;
  padding: 14px;
  /* padding-top: 7px; */
  /* padding-bottom: 7px; */
  line-height: 22px;
  min-height: 38px;
  font-size: 14px;
}
::v-deep th {
  padding: 13px;
  text-align: center;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold !important;
}
.cell {
  text-align: center;
}
th {
  position: sticky;
  top: 0;
}
th:nth-child(2) {
  text-align: left;
}
td:nth-child(2) {
  text-align: left;
  width: 20%;
}

#NS {
  text-align: center;
  font-size: 1.5rem;
  padding-top: 2%;
  padding-bottom: 2%;
}
td.posnum {
  padding: 5px;
  background-color: transparent;
  color: #707070;
  padding-top: 8px;
  padding-bottom: 4px;
  display: block;
  max-width: 58px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2px;
  margin-bottom: 0px;
  font-weight: 500;
}
@media only screen and (max-width: 480px) {
  .noData {
    height: 50vh;
  }
  .cell {
    width: 1%;
  }
  .name {
    /* width: 3%; */
    width: auto;
  }
  th:nth-child(3) {
    display: none;
  }
  td:nth-child(3) {
    display: none;
  }
  .playerName {
    padding-left: 15px;
  }
}
</style>
